import React from 'react';
import { SelectionProps } from '@tanium/react-use-selection';

export type RibbonListSelectionContextType<TId> = Pick<
  SelectionProps<TId>,
  'isSelectable' | 'isIdSelected' | 'toggleSelection'
>;

export const RibbonListSelectionContext = React.createContext(
  {} as RibbonListSelectionContextType<unknown>,
);
